import { makeEventFunctions } from '@deephaven/golden-layout';
import { ConsoleEvent } from "./events/index.js";
/**
 * Represents a Core (Community) console session. Mirrors the
 * `CommonConsoleSession` interface used in Enterprise (without the
 * Enterprise-only `QueryInfo` field).
 */
var sessionOpenedFns = makeEventFunctions(ConsoleEvent.SESSION_OPENED);

/**
 * Listen for session opened events
 * @param eventEmitter The event emitter to listen on
 * @param session The session that was opened
 */
export var listenForSessionOpened = sessionOpenedFns.listen;

/**
 * Emit a session opened event
 * @param eventEmitter The event emitter to emit the event on
 * @param session The session that was opened
 */
export var emitSessionOpened = sessionOpenedFns.emit;

/**
 * Use a session opened event listener
 * @param eventEmitter The event emitter to listen on
 * @param session The session that was opened
 */
export var useSessionOpenedListener = sessionOpenedFns.useListener;
var sessionClosedFns = makeEventFunctions(ConsoleEvent.SESSION_CLOSED);

/**
 * Listen for session closed events
 * @param eventEmitter The event emitter to listen on
 * @param session The session that was closed
 */
export var listenForSessionClosed = sessionClosedFns.listen;

/**
 * Emit a session closed event
 * @param eventEmitter The event emitter to emit the event on
 * @param session The session that was closed
 */
export var emitSessionClosed = sessionClosedFns.emit;

/**
 * Use a session closed event listener
 * @param eventEmitter The event emitter to listen on
 * @param session The session that was closed
 */
export var useSessionClosedListener = sessionClosedFns.useListener;
//# sourceMappingURL=ConsoleEvents.js.map